var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",staticClass:"app",class:_vm.appClass},[(_vm.externalUrl)?_c('ExternaView',{attrs:{"url":_vm.externalUrl}}):[(_vm.hasHeader)?_c('Header',{staticClass:"app__header"}):_vm._e(),_c('Content'),(_vm.hasFooter)?_c('Footer',{staticClass:"app__footer"}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }